// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ArrowsClockwiseBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M25.061 22.939a1.503 1.503 0 0 1 0 2.125c-.141.14-3.5 3.439-9.061 3.439-4.214 0-7.419-2.183-9.5-4.233V26a1.5 1.5 0 0 1-3 0v-6A1.5 1.5 0 0 1 5 18.5h6a1.5 1.5 0 1 1 0 3H8.015c1.637 1.79 4.385 4 7.985 4 4.329 0 6.914-2.535 6.939-2.561a1.5 1.5 0 0 1 2.122 0ZM27 4.5A1.5 1.5 0 0 0 25.5 6v1.732C23.419 5.683 20.214 3.5 16 3.5c-5.557 0-8.92 3.299-9.061 3.439a1.503 1.503 0 0 0 2.125 2.125C9.086 9.035 11.67 6.5 16 6.5c3.6 0 6.348 2.21 7.985 4H21a1.5 1.5 0 1 0 0 3h6a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 27 4.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
